import React from 'react'
import { FaWindows, FaApple, FaLinux, FaGooglePlay, FaAppStoreIos } from "react-icons/fa";
import { HiOutlineTerminal } from "react-icons/hi";
import image1 from '../assets/images/phones.png';
import image2 from '../assets/images/logo.png';

const Download = () => {
  return (
    <>
        <div className="max-w-7xl mx-auto">
      {/* Section 1 - Mobile App */}
      <div className="py-16 px-6 lg:px-24 flex flex-col lg:flex-row justify-between items-center gap-16">
        <div className="max-w-xl">
          <h2 className="text-4xl font-bold mb-4 leading-tight">
            Trade Safely and Securely <br /> Anytime. Anywhere.
          </h2>
          <p className="text-gray-600 mb-6">
            Start with simply downloading the app. Become a better investor on the go, right in the app.
          </p>

          <div className="flex items-center gap-4 mb-2">
            <button className="flex items-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-md text-sm">
              <FaGooglePlay className="text-xl" />
              Android Download
            </button>
            <button className="flex items-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-md text-sm">
              <FaApple className="text-xl" />
              iOS Download
            </button>
          </div>

          
        </div>

        <div>
          <img
             src={image1}
            alt="Mobile & Desktop"
            className="max-w-[500px] w-full"
          />
        </div>
      </div>

      {/* Section 2 - Desktop App */}
      <div className="py-16 px-6 lg:px-24 bg-white grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <img
            src={image2}
            alt="Tillionx"
            className="w-full max-w-[600px]"
          />
        </div>

        <div>
          <h3 className="text-2xl font-semibold mb-4">Download Tillionx for Desktop</h3>

          <div className="space-y-3">
            <button className="flex items-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-md text-sm">
              <FaWindows className="text-xl" />
              Windows
            </button>

            <p className="text-sm text-gray-500 cursor-pointer hover:underline">
              Other desktop option
            </p>

            <div className="flex gap-4">
              <button className="flex items-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-md text-sm">
                <FaApple className="text-xl" />
                Mac OS
              </button>
              <button className="flex items-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-md text-sm">
                <FaLinux className="text-xl" />
                Linux
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3 - Authenticator */}
      <div className="py-16 px-6 lg:px-24 bg-gray-50 text-center">
        <h3 className="text-2xl font-semibold mb-6">Download Authenticator</h3>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
          <button className="flex items-center gap-2 px-6 py-3 border rounded-md bg-white text-gray-800 hover:bg-gray-100 text-sm">
            <FaGooglePlay className="text-lg" />
            Download from Google Play
          </button>
          <button className="flex items-center gap-2 px-6 py-3 border rounded-md bg-white text-gray-800 hover:bg-gray-100 text-sm">
            <FaApple className="text-lg" />
            Download from App Store
          </button>
        </div>
      </div>

      {/* Section 4 - Tillionx API */}
      <div className="py-16 px-6 lg:px-24 text-center bg-white">
        <h3 className="text-2xl font-semibold mb-6">Tillionx API Documents</h3>
        <button className="flex mx-auto items-center gap-2 px-6 py-3 border rounded-md bg-white hover:bg-gray-100 text-sm text-gray-800">
          <HiOutlineTerminal className="text-lg" />
          Tillionx API
        </button>
      </div>
    </div>
    </>
  )
}

export default Download